;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import svg from "../../../../common/icons/assets/retreats-icon.svg"
import SvgAsset from "./SvgAsset"

function RetreatsIcon({ color }) {
  return (
    <SvgAsset
      svg={svg}
      viewBox="0 0 1200 1200"
      width="85px"
      height="85px"
      color={color ? color : "#AAAAAA"}
    />
  )
}
export default RetreatsIcon
